module.exports = __webpack_public_path__ + "img/01.821fe48e.png";